import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { TodoView } from "../VIEW/TodoView";
import { useAuth } from "../FIREBASE/useAuth";
import routeUrls from "../COMPONENTS/navbar/navLink";

function TodoPage() {
  const { user, loading } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (!loading && !user) history.replace(`${routeUrls.LOGIN}?from=${routeUrls.TODO}`);
  }, [user, loading]);

  if (loading || !user) return null;
  return <TodoView uid={user.uid} />;
}

export default TodoPage;
